import { useState } from "react";
import styled from "styled-components";

import Graph from "../sections/Visualization";
import DragDropUpload from "../sections/UploadedFiles";
import Model from "../sections/Model";
import Simulator from "../sections/Simulator";

import fileLogo from "../assets/files.svg";
import modelLogo from "../assets/model.svg";
import networkLogo from "../assets/network.svg";
import rocketlogo from "../assets/rocket.svg";
import melody from "../assets/melody2.svg";
import slide from "../assets/sidebar.svg";

import Img from "../components/Img";
import { useFile } from "../Contexts";
import { Link } from "react-router-dom";

// ── Constants ────────────────────────────────────────────────────────────────

const NAV_ITEMS = [
  { name: "Uploaded Files", logo: fileLogo },
  { name: "Model",          logo: modelLogo },
  { name: "Visualization",  logo: networkLogo },
  { name: "Simulation",     logo: rocketlogo },
];

// ── Styled Components ────────────────────────────────────────────────────────

const Container = styled.div`
  font-family: sans-serif;
  display: flex;
  width: 100vw;
  height: 100%;
`;

const SideBar = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #0f2a7c;
  padding: 8px 24px;
  justify-content: flex-start;
  height: calc(100% - 30px);
  position: fixed;
  overflow: hidden;
  margin: 10px;
  border-radius: 40px;
  z-index: 111;

  > div {
    margin-bottom: 0.5rem;
    color: #fff;
    cursor: pointer;
    padding: 1rem;
  }

  > div.active {
    background-color: #0c3788ff;
    border-radius: 8px;
  }
`;

const SideItem = styled.div`
  display: flex;
  align-items: center;

  img {
    margin-right: 10px;
  }
`;

const MelodyImage = styled.div`
  background-color: #194089;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
`;

const SidebarHeader = styled.div`
  border-bottom: 2px solid #fff;
  margin-bottom: 20px;
`;

const SidebarTitle = styled(Link)`
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin: 0 10px;
`;

const CollapseButton = styled.div`
  position: absolute;
  right: 10px;
  top: 24px;
`;

const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const ModelContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

const GraphContainer = styled.div`
  display: flex;
  justify-content: ${({ $open }) => ($open ? "flex-end" : "center")};
  padding: ${({ $open }) => ($open ? "0 24px" : "0")};
  width: 100%;
`;

const SimulatorContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: ${({ $open }) => ($open ? "0 24px" : "0")};
  width: 100%;
  
`;

const UploadArea = styled.div`
  border-radius: 24px;
  width: 50%;
  display: flex;
  justify-content: center;
`;

// ── Component ────────────────────────────────────────────────────────────────

export default function Dish() {
  const [currentSelect, setCurrentSelect] = useState(NAV_ITEMS[0]);
  const { selectedFile, open, setOpen } = useFile();

  const resetToUpload = () => setCurrentSelect(NAV_ITEMS[0]);
  const isActive = (item) => currentSelect.name === item.name;

  return (
    <Container>
      <SideBar>
        {open ? (
          <SidebarHeader>
            <SidebarTitle >DiSH</SidebarTitle>
            <CollapseButton onClick={() => setOpen(false)}>
              <Img src={slide} />
            </CollapseButton>
          </SidebarHeader>
        ) : (
          <MelodyImage onClick={() => setOpen(true)}>
            <Img src={melody} width="25px" />
          </MelodyImage>
        )}

        {NAV_ITEMS.map((item) => (
          <SideItem
            key={item.name}
            className={isActive(item) ? "active" : ""}
            onClick={() => setCurrentSelect(item)}
          >
            <Img src={item.logo} />
            {open && item.name}
          </SideItem>
        ))}
      </SideBar>

      {isActive(NAV_ITEMS[0]) && (
        <MainContainer>
          <UploadArea>
            <DragDropUpload
              accept=".xlsx"
              multiple
              maxSizeMB={25}
              onFilesChange={(fs) => console.log("Selected files:", fs)}
            />
          </UploadArea>
        </MainContainer>
      )}

      {isActive(NAV_ITEMS[1]) && (
        <ModelContainer>
          <Model selectedFile={selectedFile} setCurrentSelect={resetToUpload} />
        </ModelContainer>
      )}

      {isActive(NAV_ITEMS[2]) && (
        <GraphContainer $open={open}>
          <Graph selectedFile={selectedFile} />
        </GraphContainer>
      )}

      {isActive(NAV_ITEMS[3]) && (
        <SimulatorContainer $open={open}>
          <div style={{ width: "100%", padding: "12px" }}>
            <Simulator selectedFile={selectedFile} />
          </div>
        </SimulatorContainer>
      )}
    </Container>
  );
}